var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBucketMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.42002 10.5C1.42002 10.1548 1.69984 9.875 2.04502 9.875L17.9549 9.875C18.3001 9.875 18.5799 10.1548 18.5799 10.5C18.5799 10.8452 18.3001 11.125 17.9549 11.125L2.04502 11.125C1.69984 11.125 1.42002 10.8452 1.42002 10.5Z",
    fill: "#0B0C0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBucketMinus);
export default __webpack_public_path__ + "static/media/bucket_minus.9f10104bf54f6776579ca15cef24dc9a.svg";
export { ForwardRef as ReactComponent };